import { memo } from 'react';

import type { SideNavItem } from '../types';

import { SideNavItemRow } from './SideNavItemRow';
import { SideNavRailItem } from './SideNavRailItem';

interface SideNavEntryProps {
  isRail: boolean;
  item: SideNavItem;
}

/** One entry, as a full row in the sidebar or a labelled icon on the rail. */
export const SideNavEntry = memo(function SideNavEntry({
  isRail,
  item,
}: SideNavEntryProps) {
  return isRail ? (
    <SideNavRailItem item={item} />
  ) : (
    <SideNavItemRow item={item} />
  );
});
